namespace SolovisGateway.Admin.Users {

    /**
     * AdminUserListModel is the backing model for rows in AdminUserListControl.
     */
    export class AdminUserListModel {
        fullName: string;
        primaryEmail: string;
        contactEmail: string;
        managingOrganizationName: string;
        isLoginDisabled: boolean;
        isGatewayAdmin: boolean;
        id: number;
        code: string;
        managingOrganizationId: number;
        requireMfa: boolean;
        acceptedTermsOfServiceId?: number;
        lastLoggedIn: number;

        constructor(data?: Partial<AdminUserListModel>) {
            if (data) {
                this.fullName = data.fullName;
                this.primaryEmail = data.primaryEmail;
                this.contactEmail = data.contactEmail;
                this.managingOrganizationName = data.managingOrganizationName;
                this.isLoginDisabled = data.isLoginDisabled;
                this.isGatewayAdmin = data.isGatewayAdmin;
                this.id = data.id;
                this.code = data.code;
                this.managingOrganizationId = data.managingOrganizationId;
                this.requireMfa = data.requireMfa;
                this.acceptedTermsOfServiceId = data.acceptedTermsOfServiceId;
                this.lastLoggedIn = data.lastLoggedIn;
            }
        }
    }
}